import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import NormalBoxContainer from "../../containers/shared/NormalBoxContainer";
import InputField from "../../components/shared/InputField";
import NormalButton from "../../components/shared/NormalButton";
import apiClient from "../../components/utils/apiClient";
import useUser from "../../components/helpers/useUser";

const RechargeWalletPage = () => {
    const {t,i18n} = useTranslation();
    const navigate = useNavigate();
    const pageTitle = {title: 'شحن المحفظة', subTitle: 'يمكنك شحن رصيد محفظتك من هنا'};
    useDocumentTitle('شحن المحفظة');

    const [user, setUser] = useUser();

    const [customAmout, setCustomAmout] = useState(null);

    const [selectedFixedAmount, setSelectedFixedAmount] = useState(null);

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const [isLoading, setIsLoading] = useState(true);
    const [businessId, setBusinessId] = useState(null);
    const [FixedAmounts, setFixedAmounts] = useState([]);

    useEffect(()=>{
        if(user) {
            setIsLoading(false);
            setBusinessId(user?.business?._id ? user?.business._id : user?.business);
        }
    },[user])

    useEffect(()=>{
        if(businessId) {
            if(['68b56c61d0a6349234c0aab1','68500f76557174fa7db74578'].includes(businessId)) {
                setFixedAmounts([
                    {price: '5', color:'fill-[#5381B2]/90 group-hover:fill-[#5381B2]', selected: '!fill-[#5381B2]', amount: 5},
                    {price: '5', color:'fill-[#042254]/90 group-hover:fill-[#042254]', selected: '!fill-[#042254]', amount: 5},
                    {price: '5', color:'fill-[#8D8D8D]/90 group-hover:fill-[#8D8D8D]', selected: '!fill-[#8D8D8D]', amount: 5},
                    {price: '5', color:'fill-[#A38900]/90 group-hover:fill-[#A38900]', selected: '!fill-[#A38900]', amount: 5},
                ]);
            } else {
                setFixedAmounts([
                    {price: '10,000', color:'fill-[#5381B2]/90 group-hover:fill-[#5381B2]', selected: '!fill-[#5381B2]', amount: 10000},
                    {price: '50,000', color:'fill-[#042254]/90 group-hover:fill-[#042254]', selected: '!fill-[#042254]', amount: 50000},
                    {price: '100,000', color:'fill-[#8D8D8D]/90 group-hover:fill-[#8D8D8D]', selected: '!fill-[#8D8D8D]', amount: 100000},
                    {price: '200,000', color:'fill-[#A38900]/90 group-hover:fill-[#A38900]', selected: '!fill-[#A38900]', amount: 200000},
                ]);
            }
        }
    },[businessId])

    const handleClickFixedAmout = (index) => {
        setSelectedFixedAmount(index+1);
        setCustomAmout(null);
    }

    const handleChangeCustomAmout = (e) => {
        if(e.target.value === '' || (e.target.value > 0 && /^[0-9\b]+$/.test(e.target.value))) {
            console.log(e.target.value);
            setCustomAmout(e?.target?.value);
            setSelectedFixedAmount(null);
        }
    }

    const handleRechargeAction = async() => {
        setIsSubmitDisabled(true);
        let callback;
        callback =  window?.location?.href?.replace('/recharge','');
        let body = {frontEndCallback:callback}
        if(customAmout) {
            body.amount = customAmout;
        }
        if(selectedFixedAmount) {
            body.amount = FixedAmounts[selectedFixedAmount-1]?.amount;
            body.isFixedAmount = true;
        }
        try {
        const response = await apiClient.post(`/b-business/recharge`,body);
        if(response?.data) {
          window.location.href = response?.data?.formUrl;
          return false;
        } else {
          setIsSubmitDisabled(false);
        }
        } catch(err) {setIsSubmitDisabled(false);}
    }


    useEffect(()=>{
        if((customAmout && customAmout >= parseInt(FixedAmounts[0]?.amount)) || (selectedFixedAmount || selectedFixedAmount === 0)) {
            setIsSubmitDisabled(false);
        } else {
            setIsSubmitDisabled(true);
        }
    },[customAmout,selectedFixedAmount])
    
  return (
    businessId && <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            <MainContent noMargin={true}>
                <div className="w-full max-w-[1220px] py-[10px]">
                    <NormalBoxContainer label={`من فضلك قم بتحديد باقة عقد الصيانة لشحن رصيد المحفظة`}>
                        <div className="text-[16px] font-[500] text-grey-600 mb-[10px]">اختر قيمة عقد الصيانة</div>
                        <div className="flex flex-wrap gap-[20px] pb-[16px]">
                            {FixedAmounts?.map((card,index)=>{
                                return (
                                    <div key={card.price} className={`group relative cursor-pointer border-[2px] w-[270px] ${index+1 === selectedFixedAmount ? 'border-[#0CB450]' : 'border-[transparent]'} rounded-[15px] p-[1px]`} onClick={()=>handleClickFixedAmout(index)}>
                                        <svg width="100%" height="189" viewBox="0 0 264 189" fill="none" xmlns="http://www.w3.org/2000/svg" className="">
                                            <g clip-path="url(#clip0_4689_37360)">
                                                <rect width="264" height="189" rx="12" className={`${card.color} ${index+1 === selectedFixedAmount ? card.selected : ''}`} />
                                                <circle opacity="0.5" cx="285" cy="201" r="49.5" stroke="white"/>
                                                <circle opacity="0.5" cx="6" cy="15" r="74.5" stroke="white"/>
                                                <circle opacity="0.5" cx="26" cy="7" r="54.5" stroke="white"/>
                                                <circle cx="24" cy="24" r="15.5" fill="white" fillOpacity="0.4" stroke="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4689_37360">
                                                    <rect width="264" height="189" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>

                                        {index+1 === selectedFixedAmount && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-[13px] end-[13px]">
                                            <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z" fill="#0CB450"/>
                                        </svg>}

                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-[20px] start-[16px]">
                                            <path d="M26.2997 3.33203H13.6997C7.39968 3.33203 5.83301 5.01536 5.83301 11.732V30.4987C5.83301 34.932 8.26634 35.982 11.2163 32.8154L11.233 32.7987C12.5997 31.3487 14.683 31.4654 15.8663 33.0487L17.5497 35.2987C18.8997 37.082 21.083 37.082 22.433 35.2987L24.1163 33.0487C25.3163 31.4487 27.3997 31.332 28.7663 32.7987C31.733 35.9654 34.1497 34.9154 34.1497 30.482V11.732C34.1663 5.01536 32.5997 3.33203 26.2997 3.33203ZM24.583 17.9154H15.4163C14.733 17.9154 14.1663 17.3487 14.1663 16.6654C14.1663 15.982 14.733 15.4154 15.4163 15.4154H24.583C25.2663 15.4154 25.833 15.982 25.833 16.6654C25.833 17.3487 25.2663 17.9154 24.583 17.9154Z" fill="white"/>
                                        </svg>

                                        <div className="text-white font-[500] text-[36px] absolute top-[65px] start-[16px]">
                                            {card.price}
                                            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-[unset] ms-[4px]">
                                                <g clip-path="url(#clip0_5244_34607)">
                                                    <path d="M13.6919 21.2629C13.2994 22.1125 13.0398 23.0346 12.9404 24.0016L21.2483 22.2778C21.6409 21.4283 21.9002 20.506 21.9998 19.5391L13.6919 21.2629Z" fill="white"/>
                                                    <path d="M21.2485 17.1119C21.6411 16.2624 21.9006 15.3401 22 14.3732L15.5284 15.7167V13.134L21.2483 11.9476C21.6409 11.0981 21.9004 10.1758 21.9998 9.20886L15.5282 10.5512V1.26324C14.5366 1.8067 13.6559 2.53011 12.94 3.38341V11.0883L10.3518 11.6253V0C9.36019 0.543271 8.47951 1.26687 7.76362 2.12017V12.1621L1.97251 13.3632C1.57993 14.2127 1.32023 15.135 1.22061 16.1019L7.76362 14.7447V17.9971L0.751508 19.4515C0.358923 20.301 0.0994182 21.2233 0 22.1902L7.33973 20.6678C7.93721 20.5465 8.45074 20.2017 8.78462 19.7272L10.1307 17.7793V17.7789C10.2704 17.5774 10.3518 17.3344 10.3518 17.0727V14.2078L12.94 13.6708V18.8361L21.2483 17.1115L21.2485 17.1119Z" fill="white"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5244_34607">
                                                        <rect width="22" height="24" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>

                                        <div className="text-white text-[18px] font-[500] absolute bottom-[20px] start-[16px]">
                                            عقد صيانة بقيمة
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                        <div className="border-t-[1px] border-t-grey-200 pt-[16px] pb-[6px]">
                            <div className="text-[16px] font-[500] text-grey-600 mb-[10px]">أو يمكنك إدخال القيمة المراد شحنها</div>
                            <div className="relative w-full">
                                {!customAmout ? <span className="absolute start-[13px] top-[12px] text-grey-300 text-[16px] font-[500] z-[1] pointer-events-none select-none">
                                    الحد الأدنى المسموح به هو 10,000 
                                    <img src="/assets/images/SAR-med.svg" alt="" className="w-[16px] select-none opacity-15 inline-block ms-[3px]" />
                                </span> : ''}
                                <img src="/assets/images/SAR-med.svg" alt="" className="absolute end-[15px] w-[17px] bottom-[15px] z-[1] select-none opacity-50" />
                                <InputField value={customAmout ? customAmout : ''} onChange={(e)=>handleChangeCustomAmout(e)} />
                            </div>
                        </div>
                        <div className="border-t-[1px] border-t-grey-200 pt-[16px] text-end">
                            <NormalButton label={'شحن الرصيد'} isDisabled={isSubmitDisabled} onClick={()=>handleRechargeAction()} />
                        </div>
                    </NormalBoxContainer>
                </div>
            </MainContent>
        </PageMain>
        

    </div>
  );
};

export default RechargeWalletPage;
